const Form096TC = {
    title: "（前電子表格編號：EDB 113）",
    stepName: {
        information: "基本資料",
        partA: "個人資料",
        partB: "聲明",
        confirmation: "確認",
    },
    notes: {
        notesTitle: "填寫表格注意事項",
        declaration: "本人謹此聲明：",
        declaration1: "本人已閱讀第一部分「填寫表格注意事項」",
        declaration2:
            "本人明白如我曾遞交多於一份的申請，只有最後遞交的申請會被處理。",
        declaration3: `本人明白倘若故意在填寫本申請書時虛報資料或隱瞞重要事實，或未有在申請書內所提供資料已作更改後通知招聘職系／部門，可令本人喪失獲政府錄用的資格；即使已獲政府錄用，亦可遭終止聘用。`,
        declaration4: `本人同意政府可就進行與政府招聘工作及僱用有關的事宜，及為核實上述資料而進行必要的查詢。本人授權所有政府部門及其他組織或機構可就這些查詢，透露任何有關的紀錄及資料（其中包括，在提出聘任前，向本人的現行及／或前僱主索取一份僱主推薦書／工作表現評核報告；向有關當局／機構／醫護人員索取本人的體格檢查報告、醫事委員會報告或診療紀錄，及將有關資料送交其他當局／機構／醫護人員；以及向有關的政府部門／院校／機構查詢本人的學歷／語文／專業資格和索取有關紀錄，及將有關資料送交其他政府部門／當局／機構進行學歷評審）。本人謹此授權香港警務處處長或其代表把所有關於我的犯罪紀錄及詳情發放予有關政府部門／當局／機構。就我的職位申請，我也同意當有需要時，可套取我的指紋以核實我的犯罪紀錄。`,
        declaration5: `本人明白並同意，如有需要，上述資料會送交獲授權處理有關資料的政府部門及其他組織或機構，用以進行與政府招聘工作，以及其他與僱用和人力資源管理有關的事宜，例如學歷評審、體格檢查、僱主推薦及操守審查等。`,
        agreeTips: "本人已閱讀「填寫表格注意事項」。",
    },
    comma: "，",
    tooltip: {
        university:
            "註：持非本地學歷者，你或許需要向香港學術及職業資歷評審局申請進行學歷評估。",
        multiSelect: "請選擇合適的一項，可選擇多項。",
        threeSubject: "中小學類別可填寫不多於三個科目",
        notesTips: "填寫表格注意事項",
    },
    label: {
        partI: "第一部分",
        partITips:
            "如申請下學年的職位，可以在本學年4月1日至8月31日期間遞交本表格",
        payPeriod: "申請擔任日薪代課教師／月薪臨時教師職位",
        servingPeriod: "可擔任日薪代課教師／月薪臨時教師的日期",
        servingDateTips:
            "如未能在上述的整個學年內擔任日薪代課教師／月薪臨時教師，請註明可任職的日期",
        startDateOfServ: "由",
        endDateOfServ: "至",
        partII: "第二部分",
        title1: "(i) 個人資料",
        nameTitle: "姓名：\n(如香港身份證所示)",
        english: "（英文）",
        chinese: "（中文）",
        surname: "姓氏",
        otherName: "名字",
        englishSurname: "姓名（如香港身份證所示）（英文）姓氏",
        englishOtherName: "姓名（如香港身份證所示）（英文）名字",
        chineseSurname: "姓名（如香港身份證所示）（中文）姓氏",
        chineseOtherName: "姓名（如香港身份證所示）（中文）名字",
        residentHK: "香港居民身份",
        documentType: "身份證明書類別",
        hkidCardNo: "香港身份證號碼",
        otherDocumentNo: "其他身份證明文件號碼",
        idIssuePlace: "簽發地點",
        dateBirth: "出生日期",
        sexCode: "性別",
        teacherRegistrationNo: "註冊教師編號",
        title2: "(ii) 聯絡資料",
        emailAddress: "電郵地址",
        district: "居住地區",
        telNo: "住所電話",
        mobilePhoneNo: "手提電話",
        title3: "(iii) 資歷",
        titleThreeTips:
            "(請在學校面試時提供下列(A)至(C)項的資歷正本及副本，例如：證書／成績單等，以備查閱。)",
        universityTitle: "(A) 大學",
        instUnivName: "大學名稱",
        qualDegree: "所獲學位",
        yearObtain: "獲取年份",
        major: "主修",
        minor: "副修",
        trainingTitle: "(B) 師資訓練",
        instUnivCollName: "大學／教育學院名稱",
        trainCert: "所獲學位／證書／文憑",
        schLvEdu: "小學／中學教育",
        lprEngPth: "(C) 語文能力要求",
        lprEngChiTips:
            "（如果你已通過「申請豁免」及／或「參加教師語文能力評核」達到指定的語文能力要求, 請選擇合適的一項。）",
        title4: "(iv) 教學經驗",
        teachingExperienceTips:
            "（你曾否在提供正規課程的本地中學／小學日校擔任月薪學位或非學位教師， 請選擇合適的一項。）",
        teachingExperienceConfirmTips:
            "你曾否在提供正規課程的本地中學／小學日校擔任月薪學位或非學位教師",
        experienceYear: "全職教學經驗年數：",
        teachExperYear: "年",
        teachExperMonth: "月",
        teachExperTips: "註：日薪教學經驗不計算在內",
        noTeachExper:
            "請於學校面試時提供由前任學校簽發的教學服務證明書正本及副本。",
        fullTimeExperSchool: "如曾任教中四或以上，請在方格加上✓號",
        title5: "(v) 首選任教學校的地區及類別",
        location: "地區",
        schoolLevel: "類別",
        title6: "(vi) 合資格的教授科目",
        secondarySchool: "中學",
        secondarySubject1: "科目一",
        secondarySubject2: "科目二",
        secondarySubject3: "科目三",
        secSubj1S4OrAbove: "有任教中四或以上經驗",
        secSubj2S4OrAbove: "有任教中四或以上經驗",
        secSubj3S4OrAbove: "有任教中四或以上經驗",
        primarySchool: "小學",
        primarySubject1: "科目一",
        primarySubject2: "科目二",
        primarySubject3: "科目三",
        subjectName: "科目名稱",
        capaAcqTips: "以英語教授非語文科目的能力：",
        acqTips:
            "（即達到以英語教授非語文科目的教師能力要求。招聘的學校可能會要求你提供文件，證明你已達到有關要求。請通過下列路徑參閱相關資料<b>（教育局主頁 >教育制度及政策> 小學及中學教育> 中學教育適用> 教學語言> 參考文件> 常見問題</b>（與教師能力相關部分）<b>）</b>）",
        capaNaTips: "（例如：以母語教授非語文科目、或只教授語文科目）",
        title7: "(vii) 你是否教育局的退休／離職公務員？",
        leftCivilServiceTips: "如答「是」，請填寫",
        dateLeftCivilService: "離開教育局的日期",
        receivingPension: "及是否正在支取長俸",
        title8: "(viii) 你是否獲批准參加提早退休計劃的資助或官立學校教師？",
        ersIndicTips:
            "如答「是」，請參閱第一部分「填寫表格注意事項」的 <u>第12點</u>。",
        partIII: "第三部分",
        chineseNameCode: "中文姓名電碼",
        placeBirth: "出生地點",
        residentialAddress1: "住所地址第一行",
        residentialAddress2: "住所地址第二行",
        residentialCountry: "居住國家／區域",
        title9: "(ix) 你是否曾遭取消／拒絕其教師註冊資格？",
        title10:
            "(x) 就你所知，教育局是否曾就你的專業失德行為，發出譴責／警告／勸喻信？",
        title11:
            "(xi) 就你所知，你是否曾被／正被學校或教育局調查有關你的專業失德的指控？",
        title12: "(xii) 你是否曾在香港或其他地方被裁定干犯刑事罪行？",
        title13:
            "(xiii) 就你所知，你是否涉及任何在進行中的刑事訴訟或調查（包括但不限於被警方逮捕或拘捕）？",
        detail: "如有，請列明詳情",
    },
    select: {
        payPeriodOption: {
            D: "日薪代課教師",
            M: "月薪臨時教師",
            E: "兩者皆可",
        },
        servingPeriodOption: {
            C: "本學年（{{schoolYear}}學年）",
            N: "下一學年（{{nextSchoolYear}}學年）",
            B: "本學年及下一學年",
        },
        residentHKOption: {
            P: "永久性居民",
            N: "非永久性居民",
        },
        documentTypeOption: {
            "01": "香港身份證",
            "02": "護照",
            "03": "回港證",
            "05": "香港簽證身份書",
            "06": "入境許可證（家屬）",
            "07": "簽證身份陳述書",
            "08": "單程證",
            "09": "其他",
        },
        placeIssueOption: {
            999: "其他",
            AUS: "澳洲",
            AUT: "奧地利",
            BRA: "巴西",
            BRI: "英國",
            CAN: "加拿大",
            CHI: "中國",
            FRA: "法國",
            GER: "德國",
            HK: "香港",
            IND: "印度",
            JPN: "日本",
            KOR: "韓國",
            MAC: "澳門",
            MYS: "馬來西亞",
            NLD: "荷蘭",
            NPL: "尼泊爾",
            NZL: "紐西蘭",
            PAK: "巴基斯坦",
            PHL: "菲律賓",
            PRT: "葡萄牙",
            SGP: "新加坡",
            SPA: "西班牙",
            SWI: "瑞士",
            THA: "泰國",
            TWN: "台灣",
            UK: "聯合王國",
            USA: "美國",
            VNM: "越南",
        },
        placeBirthOption: {
            HK: "香港",
            MO: "澳門",
            TW: "台灣",
            CN: "內地",
            AF: "Afghanistan",
            AX: "Aland Islands",
            AL: "Albania",
            DZ: "Algeria",
            AS: "American Samoa",
            AD: "Andorra",
            AO: "Angola",
            AI: "Anguilla",
            AQ: "Antarctica",
            AG: "Antigua and Barbuda",
            AR: "Argentina",
            AM: "Armenia",
            AW: "Aruba",
            AU: "Australia",
            AT: "Austria",
            AZ: "Azerbaijan",
            BS: "Bahamas",
            BH: "Bahrain",
            BD: "Bangladesh",
            BB: "Barbados",
            BY: "Belarus",
            BE: "Belgium",
            BZ: "Belize",
            BJ: "Benin",
            BM: "Bermuda",
            BT: "Bhutan",
            BO: "Bolivia",
            BA: "Bosnia and Herzegovina",
            BW: "Botswana",
            BV: "Bouvet Island",
            BR: "Brazil",
            IO: "British Indian Ocean Territory",
            BN: "Brunei Darussalam",
            BG: "Bulgaria",
            BF: "Burkina Faso",
            BI: "Burundi",
            KH: "Cambodia",
            CM: "Cameroon",
            CA: "Canada",
            CV: "Cape Verde",
            KY: "Cayman Islands",
            CF: "Central African Republic",
            TD: "Chad",
            CL: "Chile",
            CX: "Christmas Island",
            CC: "Cocos (Keeling) Islands",
            CO: "Colombia",
            KM: "Comoros",
            CG: "Congo",
            CK: "Cook Islands",
            CR: "Costa Rica",
            CI: "Cote D'Ivoire",
            HR: "Croatia",
            CU: "Cuba",
            CY: "Cyprus",
            CZ: "Czech Republic",
            KP: "Korea",
            DK: "Denmark",
            DJ: "Djibouti",
            DM: "Dominica",
            DO: "Dominican Republic",
            EC: "Ecuador",
            EG: "Egypt",
            SV: "El Salvador",
            GQ: "Equatorial Guinea",
            ER: "Eritrea",
            EE: "Estonia",
            ET: "Ethiopia",
            FK: "Falkland Islands (Malvinas)",
            FO: "Faroe Islands",
            FM: "Federated States of Micronesia",
            FJ: "Fiji",
            FI: "Finland",
            FR: "France",
            GF: "French Guiana",
            PF: "French Polynesia",
            TF: "French Southern Territories",
            GA: "Gabon",
            GM: "Gambia",
            DE: "Germany",
            GN: "Guinea",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HT: "Haiti",
            HM: "Heard Island and Mcdonald Islands",
            VA: "Holy See (Vatican City State)",
            HN: "Honduras",
            HU: "Hungary",
            IS: "Iceland",
            IM: "Isle of Man",
            IL: "Israel",
            IT: "Italy",
            JM: "Jamaica",
            JP: "Japan",
            JE: "Jersey",
            JO: "Jordan",
            KZ: "Kazakhstan",
            KE: "Kenya",
            KI: "Kiribati",
            KW: "Kuwait",
            KG: "Kyrgyzstan",
            LA: "Lao People's Democratic Republic",
            LV: "Latvia",
            LB: "Lebanon",
            LS: "Lesotho",
            LR: "Liberia",
            LY: "Libyan Arab Jamahiriya",
            LI: "Liechtenstein",
            LT: "Lithuania",
            LU: "Luxembourg",
            MG: "Madagascar",
            MW: "Malawi",
            MY: "Malaysia",
            MV: "Maldives",
            ML: "Mali",
            MT: "Malta",
            MH: "Marshall Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MU: "Mauritius",
            YT: "Mayotte",
            MX: "Mexico",
            MC: "Monaco",
            MN: "Mongolia",
            ME: "Montenegro",
            MS: "Montserrat",
            MA: "Morocco",
            MZ: "Mozambique",
            MM: "Myanmar",
            NA: "Namibia",
            NR: "Nauru",
            NP: "Nepal",
            NL: "Netherlands",
            AN: "Netherlands Antilles",
            NC: "New Caledonia",
            NZ: "New Zealand",
            NI: "Nicaragua",
            NE: "Niger",
            NG: "Nigeria",
            NU: "Niue",
            NF: "Norfolk Island",
            MP: "Northern Mariana Islands",
            NO: "Norway",
            OM: "Oman",
            PK: "Pakistan",
            PW: "Palau",
            PS: "Palestinian Territory, Occupied",
            PA: "Panama",
            PG: "Papua New Guinea",
            PY: "Paraguay",
            PE: "Peru",
            PH: "Philippines",
            PN: "Pitcairn",
            PL: "Poland",
            PT: "Portugal",
            PR: "Puerto Rico",
            QA: "Qatar",
            KR: "Republic of Korea",
            MK: "Republic of Macedonia",
            MD: "Republic of Moldova",
            RE: "Reunion",
            RO: "Romania",
            RU: "Russian Federation",
            RW: "Rwanda",
            SH: "Saint Helena",
            KN: "Saint Kitts and Nevis",
            LC: "Saint Lucia",
            PM: "Saint Pierre and Miquelon",
            VC: "Saint Vincent and The Grenadines",
            WS: "Samoa",
            SM: "San Marino",
            ST: "Sao Tome and Principe",
            SA: "Saudi Arabia",
            SN: "Senegal",
            RS: "Serbia",
            SC: "Seychelles",
            SL: "Sierra Leone",
            SG: "Singapore",
            SK: "Slovakia",
            SI: "Slovenia",
            SB: "Solomon Islands",
            SO: "Somalia",
            ZA: "South Africa",
            GS: "South Georgia and The South Sandwich Islands",
            ES: "Spain",
            LK: "Sri Lanka",
            SD: "Sudan",
            SR: "Suriname",
            SJ: "Svalbard and Jan Mayen",
            SZ: "Swaziland",
            SE: "Sweden",
            CH: "Switzerland",
            SY: "Syrian Arab Republic",
            TJ: "Tajikistan",
            TZ: "Tanzania",
            TH: "Thailand",
            CD: "Congo",
            TL: "Timor-Leste",
            TG: "Togo",
            TK: "Tokelau",
            TO: "Tonga",
            TT: "Trinidad and Tobago",
            GE: "Georgia",
            TR: "Turkey",
            TM: "Turkmenistan",
            TC: "Turks and Caicos Islands",
            TV: "Tuvalu",
            UG: "Uganda",
            UA: "Ukraine",
            AE: "United Arab Emirates",
            GB: "United Kingdom",
            US: "United States",
            UM: "United States Minor Outlying Islands",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VU: "Vanuatu",
            VE: "Venezuela",
            VN: "Viet Nam",
            VG: "Virgin Islands, British",
            VI: "Virgin Islands, U.S.",
            WF: "Wallis and Futuna",
            EH: "Western Sahara",
            IN: "India",
            ID: "Indonesia",
            IQ: "Iraq",
            IE: "Ireland",
            IR: "Islamic Republic of Iran",
            TN: "Tunisia",
            GH: "Ghana",
            GI: "Gibraltar",
            GL: "Greenland",
            GD: "Grenada",
            GP: "Guadeloupe",
            GU: "Guam",
            GT: "Guatemala",
            GG: "Guernsey",
            YE: "Yemen",
            ZM: "Zambia",
            ZW: "Zimbabwe",
            GR: "Greece",
        },
        // placeBirthOption: {
        //     999: "其他",
        //     AUS: "澳洲",
        //     AUT: "奧地利",
        //     BRA: "巴西",
        //     BRI: "英國",
        //     CAN: "加拿大",
        //     CHI: "中國內地",
        //     FRA: "法國",
        //     GER: "德國",
        //     HK: "香港",
        //     IDN: "印尼",
        //     IND: "印度",
        //     JPN: "日本",
        //     KOR: "韓國",
        //     MAC: "澳門",
        //     MYS: "馬來西亞",
        //     NLD: "荷蘭",
        //     NPL: "尼泊爾",
        //     NZL: "新西蘭",
        //     PAK: "巴基斯坦",
        //     PHL: "菲律賓",
        //     PRT: "葡萄牙",
        //     SGP: "新加坡",
        //     SPA: "西班牙",
        //     SWI: "瑞士",
        //     THA: "泰國",
        //     TWN: "台灣",
        //     UK: "英國",
        //     USA: "美國",
        //     VNM: "越南",
        //     INA: "沒有資料",
        // },
        districtOption: {
            // "": "不適用",
            A: "中西區",
            B: "灣仔區",
            C: "東區",
            D: "南區",
            E: "油尖旺區",
            F: "深水埗區",
            G: "九龍城區",
            H: "黃大仙區",
            J: "觀塘區",
            K: "荃灣區",
            L: "屯門區",
            M: "元朗區",
            N: "北區",
            P: "大埔區",
            Q: "西貢區",
            R: "沙田區",
            S: "葵青區",
            T: "離島區",
            X: "中國內地",
        },
        sexOption: {
            M: "男",
            F: "女",
        },
        radioChooseOption: {
            Y: "是",
            N: "否",
        },
        locationOption: {
            hkIsland: "港島",
            kowloon: "九龍",
            newTerritoriesEast: "新界東",
            newTerritoriesWest: "新界西",
        },
        schoolLevelOption: {
            2: "小學",
            3: "中學",
        },
        capaOption: {
            CAPA_ACQ: "已獲取有關學歷",
            CAPA_NA: "不適用",
        },
        lprEngPthOption: {
            english: "英文",
            putonghua: "普通話",
        },
        schLvEduOption: {
            "": "無指定",
            primary: "小學",
            secondary: "中學",
        },
    },
    serial: {
        num0: "(a)",
        num1: "(b)",
        num2: "(c)",
        num3: "(d)",
        num4: "(e)",
        num5: "(f)",
    },
    serialChild: {
        num0: "(ⅰ)",
        num1: "(ⅱ)",
        num2: "(ⅲ)",
        num3: "(ⅳ)",
    },
    noteList: [
        // "<u>就<b>本學年</b>的教席，申請人可於學年內任何時間提交申請表格</u>，有效期不超過六個月，例如9月份提交的申請，有效期至本學年2月底；10月份提交的申請，有效期至本學年3月底。在有效期過後，申請人如有意繼續申請相關職位，須重新提交申請表格。然而，所有本學年教席的申請，將於學年底的8月31日無效。",
        // "<u>就<b>下學年</b>的教席，申請人可於本學年4月1日至8月31日遞交申請表格</u>，有效期至下學年9月30日。本局不會接受於其餘時間遞交的下學年教席申請。",
        "申請人提交的所有資料，將會在申請的有效期結束時銷毀。",
        // "如申請人在遞交申請後需要更新資料，請重新遞交申請。",
        "申請人提交的資料會交給官立學校參考。如有合適的職位空缺，學校會以電話直接與申請人聯絡，安排面試事宜。",
        "申請人在遞交申請時，<u><b>毋須</b></u>附上有關資歷或教學經驗的證明文件，但須於面試時帶同有關文件供學校查閱。如申請人持非本地學歷，必須先向香港學術及職業資歷評審局申請學歷評估，以確定符合相關教席的學歷要求。",
        "如學校邀約面試，請帶同以下文件供查閱﹕",
        "官立學校作為政府機構，須配合政府的政策，實施有關的防疫抗疫措施。申請人須遵守這些措施，其申請才獲考慮。",
        `由2023/24學年起，所有公營學校、直資學校及參加幼稚園教育計劃的幼稚園的新聘教師，均必須在公務員事務局或教育局舉辦的《基本法及香港國安法》測試中取得及格成績，方可獲考慮聘用。有關要求適用於官立學校以非公務員條件聘用的月薪臨時教師，詳情請瀏覽教育局網頁（<a href="https://www.edb.gov.hk/tc/sch-admin/admin/about-sch-staff/blnst/index.html" target="_blank">https://www.edb.gov.hk/tc/sch-admin/admin/about-sch-staff/blnst/index.html</a>）。`,
        "教育局十分重視教師的專業操守，對於曾干犯嚴重罪行或作出違法行為，或涉及專業失德行為的申請人，包括曾接獲教育局發出的譴責／警告／勸喻信，或曾被教育局取消其教師註冊／拒絕其教師註冊申請的教師，其申請不會予以考慮而不另行通知。",
        `當局已接納法律改革委員會的建議，設立性罪行定罪紀錄查核機制。香港警務處已於2011年12月1日推行有關機制。該機制只適用於向機構或企業（包括學校）應徵與兒童或精神上無行為能力人士有關工作的準僱員。由於保護學生殊為重要，學校應採用該機制，並在聘用程序最後階段，要求準僱員進行性罪行定罪紀錄查核。查核紀錄的申請須由準僱員自願提交。有關機制的詳情，載於香港警務處的網頁（<a href="http://www.police.gov.hk/scrc" target="_blank">http://www.police.gov.hk/scrc</a>）。`,
        "參加了資助學校教師提早退休計劃或教育局教學職系人員提早退休計劃的教員，在退休日期起，均不得在資助、按位津貼、直資及官立學校擔任全職或兼職的教席（包括利用為學校提供額外教師的政府津貼所產生的教席，但不超過89天的日薪兼職工作除外）。",
        "關於個人資料的收集，請留意以下各項：",
    ],
    note7: [
        "香港身份證正本；",
        "學歷文件正本及影印本，如：大學畢業證書、大學成績報告單、教育學院畢業證書或其他師資培訓證書、香港中學文憑考試證書或香港中學會考證書及/或香港高級程度會考證書；",
        "《基本法及香港國安法》測試成績證明及副本(適用於申請月薪臨時教席的教師)；",
        "教學服務證明書的正本及影印本； 及",
        "檢定教員證明書的正本及影印本（如有）。",
        // "疫苗接種記錄的正本及影印本。",
    ],
    note13: [
        "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理你的申請。",
        "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：\n香港灣仔皇后大道東213號 胡忠大廈14 樓1414室教育局官立學校組（電話：2892 6325）。",
    ],
    note13A: [
        "就<b>僱傭相關事宜</b>，包括聘用、培訓及職業前途發展、薪酬及福利、員工關係、通訊和程序遵行，辦理有關處理、核實及查證的事務；",
        "就上文10(a)(i)項所述<b>僱傭相關事宜</b>的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫<b>進行核對程序</b>的事務；",
        "為核實／更新教育局的記錄，辦理有關把<b>個人資料</b>與教育局資料庫<b>進行核對程序</b>的事務；以及",
        "辦理有關編製<b>統計資料</b>、<b>研究材料</b>及<b>政府刊物</b>的事務",
    ],
    note13C: [
        "政府其他政策局及部門，用於上文第10(a)段所述的用途；",
        "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第10(a)段所述的用途；",
        "你曾就披露個人資料給予訂明同意；以及",
        "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
    ],
    errorMsg: {
        ninYear: "获得年份需在{{year}}之后",
        dateAge: "年齡必須大於等於18歲",
        errObj1: "請選擇當前學年内的一天",
        errObj2: "须在下一學年内",
        errObj3: "须在當前年（{{curYear}}）内",
        errObj4: "须在下一學年（{{nextYear}}）内",
        errYearObtain:
            "獲取年份須早於等於當前{{curYear}}年份，且晚於出生{{bithYear}}年份",
        errTeachExper: "全職教學經驗的年數及月數不可同時輸入零",
    },
};
export default Form096TC;
